var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowrighticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.47699 18.5221L7.47086 18.529L7.46527 18.5364C7.14629 18.9579 7.18208 19.5563 7.57089 19.9375C7.99597 20.3542 8.68314 20.3542 9.10822 19.9375L16.4291 12.7605L16.4357 12.7541L16.4417 12.7472L16.523 12.6549L16.5291 12.6479L16.5347 12.6405C16.8537 12.2191 16.8179 11.6207 16.4291 11.2395L9.10822 4.06254L9.10169 4.05614L9.09471 4.05023L9.00054 3.97054L8.99353 3.96461L8.9861 3.9592C8.56057 3.64967 7.95777 3.68327 7.57089 4.06254L7.56434 4.06896L7.55828 4.07584L7.47699 4.16815L7.47086 4.17511L7.46527 4.1825C7.14629 4.60395 7.18208 5.20239 7.57089 5.58355L7.57089 5.58355L14.1163 12L7.57089 18.4164L7.56434 18.4229L7.55828 18.4298L7.47699 18.5221Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowrighticon);
export default __webpack_public_path__ + "static/media/arrowright.icon.92fc4407cdfcea2b10b587b5c8de1675.svg";
export { ForwardRef as ReactComponent };